/* General purpose animation routines, and utilities */

/// Sets the wait token ref. The
/// wait token must be a ref, as "value" is
/// called on it
function setWaitedLongEnough(waitTokenRef) {
    // Wait before showing the loading banner
    waitTokenRef.value = false;
    setTimeout(() => {
        waitTokenRef.value = true;
    }, 500);
}

export {
    setWaitedLongEnough,
};
